import { Component, OnInit } from '@angular/core';
import { GcseLocationService, TutionLocation } from '../gcselocation.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-gcse-location-details',
    templateUrl: './gcse-location-details.component.html',
    styleUrls: ['./gcse-location-details.component.css'],
    standalone: false
})
export class GcseLocationDetailsComponent implements OnInit {

    location: TutionLocation;
    safeMapUrl: SafeResourceUrl;
    activeFaqIndex: number = -1;
  
    constructor(
      private route: ActivatedRoute,
      private locationService: GcseLocationService,
      private sanitizer: DomSanitizer
    ) { }
  
    ngOnInit() {
      this.route.params.subscribe(params => {
        const town = params['town'];
        this.location = this.locationService.getLocationByTown(town);
        
        if (this.location) {
          this.safeMapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.location.mapUrl);
        }
  
        if (this.location) {
          this.safeMapUrl =
            this.sanitizer.bypassSecurityTrustResourceUrl(this.location.mapUrl);
        }
      });
    }
  
    toggleFaq(index: number) {
      this.activeFaqIndex = this.activeFaqIndex === index ? -1 : index;
    }
  
    isFaqActive(index: number): boolean {
      return this.activeFaqIndex === index;
    }

}
